import { render } from "./LogbookClickableBuilding.vue?vue&type=template&id=58ca9c66"
import script from "./LogbookClickableBuilding.vue?vue&type=script&lang=js"
export * from "./LogbookClickableBuilding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__